import authHeader from "../../../authentication/authservices/auth-header";
import { cssdApiClients } from "../../../http-common";


export const MaintenanceListingNew = (searchObj) => {
    return cssdApiClients.post(`/maintenance/listing`, searchObj);
};

export const ViewMaintenanceData = (id) => {
    return cssdApiClients.get(`/maintenance/maintenance-view/${id}`, {
        headers: authHeader(),
    });
};